import { DataSourceSetupComposite } from "./DataSourceSetupComposite";
import { DATA_SOURCES_TEST_PREFIX } from "../Utils";
import { Checkbox } from "@theorgchartdev/storybook";
import { appcstr } from "@coreapp/utils/appcstr";

export const BreatheHRSetupComposite = ({ config, onChange, index, importType, chartConfig }) => {
  const { queryall, disabledUsers } = config;

  return (
    <DataSourceSetupComposite
      config={config}
      onChange={onChange}
      index={index}
      chartConfig={chartConfig}
      showInputControls
      showConfiguration={importType !== "import"}
      showLoadHeaders={importType !== "import"}
      importType={importType}
    >
      <Checkbox
        id={"toggle-queryall"}
        data-testid={`${DATA_SOURCES_TEST_PREFIX}-breathehr-query-all-checkbox`}
        label={appcstr("breatheHR4")}
        size={"medium"}
        checked={queryall}
        onChange={() => onChange({ ...config, queryall: !queryall })}
      />
      <Checkbox
        id={"toggle-disabledUsers"}
        data-testid={`${DATA_SOURCES_TEST_PREFIX}-breathehr-disabled-users-checkbox`}
        label={appcstr("breatheHR5")}
        size={"medium"}
        checked={disabledUsers}
        onChange={() => onChange({ ...config, disabledUsers: !disabledUsers })}
      />
    </DataSourceSetupComposite>
  );
};
